module.exports = __webpack_public_path__ + "static/media/hyperloop2.ee10e9f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/hyperloop2.svg
// module id = 257
// module chunks = 0